import _ from 'lodash';
import Debug from '@/util/debug';

const debug = Debug('util:Prefill'); // eslint-disable-line

const ALLOWED_FIELDS = [
  'customer.remote_id',
  'customer.name',
  'customer.phone',
  'customer.email',
  'business_category_id',
  'facebook.email',
  'details.leadEmail',
  'details.returnUrl',
];

// Used for YELL. In case multiple clients - move this to FAM config
const FIELD_OVERWRITE = {
  sap_id: { field: 'customer.remote_id', readonly: true },
  customer_name: { field: 'customer.name', readonly: true },
  customer_email: { field: 'customer.email', readonly: true },
  customer_phone: { field: 'customer.phone', readonly: true },
  facebook_email: { field: 'facebook.email', readonly: true },
  lead_email: { field: 'details.leadEmail', readonly: true },
  business_category_id: { field: 'business_category_id', readonly: true },
  return_url: { field: 'details.returnUrl', readonly: true }, // Localsearch
};

// Used by Localsearch
const FIELD_OVERWRITE_FROM_PRESET = {
  customer_name: { field: 'customer.name', readonly: true },
  customer_remote_id: { field: 'customer.remote_id', readonly: true },
  customer_phone: { field: 'customer.phone', readonly: false },
  contact_email: { field: 'customer.email', readonly: false },
};

const PREFILL_IF_EMPTY = {
  'customer.email': ['facebook.email', 'details.leadEmail'],
};

const DATA = {
  data: {},
  readonly: [],
};

export const setPrefillData = query => {
  const overwrittenQuery = Object.assign({ readonly: [] }, _.cloneDeep(query));

  if (_.has(query, 'preset')) {
    try {
      const preset = JSON.parse(query.preset);
      if (preset) {
        Object.keys(FIELD_OVERWRITE_FROM_PRESET)
          .filter(field => _.has(preset, field))
          .forEach(field => {
            overwrittenQuery[FIELD_OVERWRITE_FROM_PRESET[field].field] = preset[field];

            if (FIELD_OVERWRITE_FROM_PRESET[field].readonly) {
              overwrittenQuery.readonly.push(FIELD_OVERWRITE_FROM_PRESET[field].field);
            }
          });
      }
    } catch (e) {
      debug.info('prefill exception:', e);
    }
  }

  // map FIELD_OVERWRITE to ALLOWED_FIELDS + readonly
  Object.keys(FIELD_OVERWRITE)
    .filter(field => _.has(overwrittenQuery, field))
    .forEach(field => {
      overwrittenQuery[FIELD_OVERWRITE[field].field] = overwrittenQuery[field];

      if (FIELD_OVERWRITE[field].readonly) {
        overwrittenQuery.readonly.push(FIELD_OVERWRITE[field].field);
      }
    });

  // prefill additional fields if empty
  Object.keys(PREFILL_IF_EMPTY)
    .filter(field => _.has(overwrittenQuery, field))
    .forEach(field => {
      PREFILL_IF_EMPTY[field]
        .filter(targetField => !overwrittenQuery[targetField])
        .forEach(targetField => overwrittenQuery[targetField] = overwrittenQuery[field]);
    });

  // set actual prefill data
  DATA.readonly = overwrittenQuery.readonly.filter(f => ALLOWED_FIELDS.includes(f));
  ALLOWED_FIELDS
    .filter(field => _.has(overwrittenQuery, field))
    .forEach(field => DATA.data[field] = overwrittenQuery[field]);

  debug('prefill: ', JSON.parse(JSON.stringify(DATA)));
};

export const clearPrefillData = () => {
  DATA.data = {};
  DATA.readonly = [];
};

export const getPrefillUrlParams = () => {
  const params = {};
  params.readonly = _.cloneDeep(DATA.readonly);
  Object.keys(DATA.data).forEach(key => {
    params[key] = _.cloneDeep(DATA.data[key]);
  });

  return params;
};

export default DATA;



// WEBPACK FOOTER //
// ./src/util/prefill.js